module.exports = __webpack_public_path__ + "img/hourglass.fd57e04a.svg";